import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'utils/baseQuery';
import { METHODS } from 'config';

interface TeamOverlapQuery {
  dates: string[];
}

interface OverlapUser {
  userId: string;
  firstName: string;
  lastName: string;
  job: string;
  leaveDates: string[];
}

interface TeamOverlapResponse {
  hasOverlap: boolean;
  overlapCount: number;
  teamSize: number;
  overlapUsers: OverlapUser[];
  warningMessage?: string;
}

const TeamOverlapApi = createApi({
  reducerPath: 'team-overlap-api',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    checkTeamOverlap: builder.mutation<TeamOverlapResponse, TeamOverlapQuery>({
      query: (body) => ({
        url: '/request/check-team-overlap',
        method: METHODS.post,
        body,
      }),
    }),
  }),
});

export const { useCheckTeamOverlapMutation } = TeamOverlapApi;
export { TeamOverlapApi };
